import { NotFoundBgLeftIcon, NotFoundBgRightIcon } from '@/components/icons';
import { NotFoundBgLeft, NotFoundBgRight, NotFoundBgWrapper } from './styled';

type NotFoundBgLayoutProps = {
  children: React.ReactNode;
};

export const NotFoundBgLayout = ({ children }: NotFoundBgLayoutProps) => {
  return (
    <NotFoundBgWrapper>
      {children}
      <NotFoundBgLeft>
        <NotFoundBgLeftIcon />
      </NotFoundBgLeft>
      <NotFoundBgRight>
        <NotFoundBgRightIcon />
      </NotFoundBgRight>
    </NotFoundBgWrapper>
  );
};
